import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'adoptionlocation',
  pure: false
})
export class AdoptionlocationPipe implements PipeTransform {
  transform(data: any, location: any): any {
    
    if (!location || location.length<1){
      return data;
    } 
    else{
        var out2=[];
    for(let d in data){
        for(let l in location){
          if(data[d].location_id===location[l]){
            out2.push(data[d]);
            break;
          }
        }
    }
    return out2;
    }
}

}
